/* ============================================================
   P5 BANK PRODUCT — Plein5 Living
   Vanilla JS, geen afhankelijkheden.
   ============================================================ */
(function () {
  'use strict';

  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var SCROLL = RM ? 'auto' : 'smooth';

  /* ---------- Geld ---------- */
  function ontcijfer(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var fmt = ontcijfer(format || '&euro;{{amount_with_comma_separator}}');
    function getal(dec, duizend, komma) {
      var delen = (cents / 100).toFixed(dec).split('.');
      var geheel = delen[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + duizend);
      return delen[1] ? geheel + komma + delen[1] : geheel;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      switch (k) {
        case 'amount': return getal(2, ',', '.');
        case 'amount_no_decimals': return getal(0, ',', '.');
        case 'amount_with_comma_separator': return getal(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return getal(0, '.', ',');
        case 'amount_with_space_separator': return getal(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return getal(0, ' ', ',');
        default: return getal(2, '.', ',');
      }
    });
  }

  /* Hele euro's zonder ",00" — voor meerprijzen, tegels en de knop */
  function formatKort(cents, format) {
    var t = formatMoney(cents, format);
    if (cents % 100 === 0) t = t.replace(/[.,]00(?!\d)/, '');
    return t;
  }

  /* ---------- Kleur → kleurfamilie ---------- */
  var FAMILIES = [
    { key: 'wit',    naam: 'Wit & crème',          kleur: '#EDE6DC' },
    { key: 'beige',  naam: 'Beige & zand',         kleur: '#C9B49A' },
    { key: 'taupe',  naam: 'Taupe & bruin',        kleur: '#7A6252' },
    { key: 'cognac', naam: 'Cognac & terracotta',  kleur: '#9A5A34' },
    { key: 'roze',   naam: 'Roze & bordeaux',      kleur: '#9D6A79' },
    { key: 'groen',  naam: 'Groen',                kleur: '#5E6B4C' },
    { key: 'blauw',  naam: 'Blauw & petrol',       kleur: '#3F5F63' },
    { key: 'grijs',  naam: 'Grijs & zwart',        kleur: '#55555A' }
  ];

  function familieNaam(key) {
    var f = FAMILIES.filter(function (x) { return x.key === key; })[0];
    return f ? f.naam : '';
  }

  function hexNaarHsl(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    var r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, s = 0, hue = 0;
    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) hue = ((g - b) / d + (g < b ? 6 : 0)) * 60;
      else if (max === g) hue = ((b - r) / d + 2) * 60;
      else hue = ((r - g) / d + 4) * 60;
    }
    return { h: hue, s: s, l: l };
  }

  function familieVan(hex) {
    var c = hexNaarHsl(hex);
    if (!c) return 'beige';
    if (c.l >= 0.80 && c.s <= 0.30) return 'wit';
    if (c.s < 0.10) return c.l < 0.62 ? 'grijs' : 'wit';
    if (c.h >= 60 && c.h < 170) return 'groen';
    if (c.h >= 170 && c.h < 262) return 'blauw';
    if (c.h >= 262 || c.h < 12) return 'roze';
    if (c.l >= 0.62) return c.s < 0.45 ? 'beige' : 'cognac';
    if (c.s >= 0.30) return 'cognac';
    if (c.l < 0.30 && c.s < 0.18) return 'grijs';
    return 'taupe';
  }

  function isLeer(groep) {
    var g = String(groep || '').toLowerCase();
    return g === 'l' || g === 'bull' || g.indexOf('leer') > -1 || g.indexOf('leder') > -1;
  }

  /* Wat de klant ziet: 'stof' of 'leer' — nooit de interne groepsletter */
  function soortTekst(groep) { return isLeer(groep) ? 'leer' : 'stof'; }

  function vormVan(o) {
    if (o.vorm) return o.vorm;
    if (/u-bank|u‑bank|u bank/i.test(o.naam || '')) return 'u';
    if (!o.lr) return 'recht';
    return Number(o.diepte) >= 200 ? 'ottomane' : 'chaise';
  }

  /* 'loungedeel' voor de gewone hoekbank, 'ligdeel' voor de grote */
  function deelNaam(o) {
    if (!o) return 'loungedeel';
    if (vormVan(o) === 'ottomane' || /ligdeel/i.test(o.naam || '')) return 'ligdeel';
    return 'loungedeel';
  }

  /* Geen eigen tekeningen: de tegel toont de afbeelding van de variant zelf (SEVN's maattekening of foto).
     Alleen als er echt niets is, een neutraal vlak met de naam. */
  function personen(o) { return o.personen ? String(o.personen) : ''; }

  /* ---------- Toetsenbord binnen een groep ---------- */
  function pijltjes(container, selector, onKies) {
    if (!container) return;
    container.addEventListener('keydown', function (e) {
      var items = Array.prototype.filter.call(container.querySelectorAll(selector), function (el) { return !el.hidden && !el.disabled; });
      var i = items.indexOf(document.activeElement);
      if (i === -1 || !items.length) return;
      var n;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % items.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + items.length) % items.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = items.length - 1;
      else return;
      e.preventDefault();
      items.forEach(function (el) { el.tabIndex = -1; });
      items[n].tabIndex = 0;
      items[n].focus();
      onKies(items[n]);
    });
  }

  function attr(s) { return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  /* ============================================================
     Initialisatie per sectie
     ============================================================ */
  function init(root) {
    if (root.dataset.pbpKlaar === '1') return;
    root.dataset.pbpKlaar = '1';

    var cfgEl = root.querySelector('[data-pbp-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[p5-bank] config ongeldig', e); return; }

    var $ = function (sel) { return root.querySelector(sel); };
    var el = {
      prijs: $('[data-pbp-prijs]'), prijsSub: $('[data-pbp-prijs-sub]'),
      tegels: $('[data-pbp-tegels]'), opsWaarde: $('[data-pbp-ops-waarde]'), opsUitleg: $('[data-pbp-ops-uitleg]'), opsLabel: $('[data-pbp-ops-label]'),
      groepen: $('[data-pbp-groepen]'), samen: $('[data-pbp-samen]'),
      richting: $('[data-pbp-richting]'), richtingLabel: $('[data-pbp-richting-label]'), richtingGroep: $('[data-pbp-richting-groep]'),
      families: $('[data-pbp-families]'), stalen: $('[data-pbp-stalen]'), meer: $('[data-pbp-meer]'), melding: $('[data-pbp-stalen-melding]'), stofWaarde: $('[data-pbp-stof-waarde]'),
      infoDot: $('[data-pbp-stofinfo-dot]'), infoNaam: $('[data-pbp-stofinfo-naam]'), infoExtra: $('[data-pbp-stofinfo-extra]'),
      form: $('[data-pbp-form]'), variantId: $('[data-pbp-variant-id]'), propStof: $('[data-pbp-prop-stof]'), propRichting: $('[data-pbp-prop-richting]'),
      atc: $('[data-pbp-atc]'), atcTekst: $('[data-pbp-atc-tekst]'), atcPrijs: $('[data-pbp-atc-prijs]'), fout: $('[data-pbp-fout]'), klarna: $('[data-pbp-klarna]'),
      stage: $('[data-pbp-stage]'), badge: $('[data-pbp-fotobadge]'),
      matenTekening: $('[data-pbp-maten-tekening]'), matenLijst: $('[data-pbp-maten-lijst]'), matenKort: $('[data-pbp-maten-kort]'),
      balk: $('[data-pbp-balk]'), balkPrijs: $('[data-pbp-balk-prijs]'), balkSub: $('[data-pbp-balk-sub]'), balkKnop: $('[data-pbp-balk-knop]'),
      kaartImg: $('[data-pbp-stofkaart-img]'), kaartKnop: $('[data-pbp-stof-groot]'), kaartZoom: $('[data-pbp-stofkaart-zoom]'),
      sam: $('[data-pbp-samenvatting]'), samStof: $('[data-pbp-sam-stof]'), samRegel: $('[data-pbp-sam-regel]'), samPrijs: $('[data-pbp-sam-prijs]'),
      zoomKnop: $('[data-pbp-zoom]'),
      lightbox: $('[data-pbp-lightbox]'), lightboxImg: $('[data-pbp-lightbox-img]'), lightboxScroll: $('[data-pbp-lightbox-scroll]'), lightboxNoot: $('[data-pbp-lightbox-noot]'), lightboxSluit: $('[data-pbp-lightbox-sluit]')
    };

    /* naam = wat de klant ziet; ov = de Shopify-optiewaarde; ovRechts = de spiegelvariant (als die bestaat).
       Zonder metafield komen de opstellingen uit de optiewaarden; de maten lezen we dan uit de naam ("98 × 216 cm"). */
    var uitOpties = (cfg.opstellingen || []).length > 0 && (cfg.opstellingen || []).every(function (o) { return o.breedte == null && o.vorm == null && !o.ovRechts; });
    var opstellingen = (cfg.opstellingen || []).map(function (o) {
      o.ov = o.ov || o.naam;
      if (!o.breedte || !o.diepte) {
        var m = String(o.naam).match(/(\d+(?:\s*\/\s*\d+)?)\s*[x×]\s*(\d+)\s*cm/i);
        if (m) {
          var dieptes = m[1].split('/').map(function (n) { return parseInt(n, 10); });
          o.diepte = o.diepte || Math.max.apply(null, dieptes);
          o.breedte = o.breedte || parseInt(m[2], 10);
        }
      }
      if (typeof o.lr !== 'boolean') o.lr = /\b(links|rechts)\b/i.test(o.naam);
      return o;
    });

    var variants = cfg.variants || [];

    /* Zonder metafield: elke optiewaarde is één tegel (links en rechts dus ieder hun eigen plaatje),
       de maat achter het streepje gaat uit de naam, en geen Links/Rechts-knop. */
    if (uitOpties) {
      var kort = opstellingen.map(function (o) { return o.breedte && o.diepte ? o.naam.replace(/\s*[-–]?\s*\d+(?:\s*\/\s*\d+)?\s*[x×]\s*\d+\s*cm\s*$/i, '').replace(/\s{2,}/g, ' ').trim() : o.naam; });
      /* Korte naam alleen als die uniek is; anders (bv. drie sierkussens) blijft de maat in de naam staan */
      var telling = {};
      kort.forEach(function (n) { telling[n] = (telling[n] || 0) + 1; });
      opstellingen.forEach(function (o, i) { if (kort[i] && telling[kort[i]] === 1) o.naam = kort[i]; o.lr = false; });
    }

    /* Elementenbank ("zelf samenstellen"): losse modules zoals "1 zits arm links", "65 zonder armen",
       "ottomane rechts". Dan wordt stap 1 een samensteller: tik elementen aan, zie het totaal, één knop
       zet alles tegelijk in de winkelwagen. Complete opstellingen (Loa, Veronique populairste) blijven gewoon één keuze. */
    var modulair = uitOpties && opstellingen.length >= 6 &&
      opstellingen.filter(function (o) { return /\b(links|rechts)\b/i.test(o.naam); }).length >= 2 &&
      opstellingen.some(function (o) { return /zonder arm|middenstuk|tussenelement/i.test(o.naam); });
    root.classList.toggle('is-modulair', modulair);
    var GROEPEN = [
      { key: 'links', naam: 'Links' },
      { key: 'midden', naam: 'Midden' },
      { key: 'hoek', naam: 'Hoek' },
      { key: 'rechts', naam: 'Rechts' },
      { key: 'compleet', naam: 'Complete bank' },
      { key: 'los', naam: 'Losse delen' },
      { key: 'overig', naam: 'Overig' }
    ];
    function groepVan(o) {
      var n = String(o.naam).toLowerCase();
      if (/\+/.test(n) || /\bcompleet\b|\bbank\b|loveseat|u-bank|hoekbank|fauteuil/.test(n)) return 'compleet';
      if (/hocker|poef|cats|honden|armsteun|hoofdsteun|kussen/.test(n)) return 'los';
      if (/zithoek|\bhoek/.test(n)) return 'hoek';
      if (/\blinks\b/.test(n)) return 'links';
      if (/\brechts\b/.test(n)) return 'rechts';
      if (/zonder arm|middenstuk|tussenelement|zits/.test(n)) return 'midden';
      return 'overig';
    }

    /* Plaatje van een opstelling: metafield-afbeelding, anders de afbeelding van de Shopify-variant zelf */
    function beeldVoor(o, richting) {
      if (!o) return '';
      if (richting === 'Rechts' && o.imageRechts) return o.imageRechts;
      if (o.image) return o.image;
      var ov = (richting === 'Rechts' && o.ovRechts) ? o.ovRechts : o.ov;
      for (var i = 0; i < variants.length; i++) { if (variants[i].opstelling === ov && variants[i].fotoUrl) return variants[i].fotoUrl; }
      return '';
    }
    function tegelBeeld(o, richting) {
      var src = beeldVoor(o, richting);
      return src ? '<img src="' + attr(src) + '" alt="" loading="lazy" decoding="async">' : '<span class="pbp-tegel__leeg" aria-hidden="true">' + attr(o.naam) + '</span>';
    }

    function ovVan(o) {
      if (!o) return null;
      if (o.lr && o.ovRechts && state.richting[o.naam] === 'Rechts') return o.ovRechts;
      return o.ov;
    }
    var stoffen = (cfg.stoffen || []).map(function (s) {
      return { naam: s.naam, groep: s.groep, foto: s.foto || '', fotoGroot: s.fotoGroot || '', kleur: s.kleur || '#C9B49A', info: s.info || '', familie: familieVan(s.kleur), leer: isLeer(s.groep) };
    });
    /* Geen stoffenlijst? Dan geen stofblok; de prijs volgt dan alleen de opstelling. */
    if (!stoffen.length) {
      cfg.heeftStofgroep = false;
      var stofBlok = root.querySelector('[data-pbp-stofblok]');
      if (stofBlok) stofBlok.hidden = true;
    }

    /* Foto's koppelen via alt-tekst */
    var fotoStof = {}, fotoFamilie = {}, fotoOpstelling = {}, slideInfo = {};
    (cfg.fotos || []).forEach(function (f) {
      var alt = String(f.alt || '').trim();
      var m;
      if ((m = alt.match(/^stof\s*:\s*(.+)$/i))) { fotoStof[m[1].trim().toLowerCase()] = f.id; slideInfo[f.id] = { type: 'stof', waarde: m[1].trim() }; }
      else if ((m = alt.match(/^kleur\s*:\s*(.+)$/i))) { fotoFamilie[m[1].trim().toLowerCase()] = f.id; slideInfo[f.id] = { type: 'kleur', waarde: m[1].trim().toLowerCase() }; }
      else if ((m = alt.match(/^opstelling\s*:\s*(.+)$/i))) { fotoOpstelling[m[1].trim().toLowerCase()] = f.id; slideInfo[f.id] = { type: 'opstelling', waarde: m[1].trim() }; }
    });

    var state = { opstelling: null, richting: {}, stof: null, familie: 'alle', alles: false, samen: {}, groep: 'alle', diep: 'alle' };
    /* Sommige elementenbanken hebben elk element ook "diep" (grotere zitdiepte): dan een extra filter Normaal/Diep */
    function isDiep(o) { return /\bdiep\b/i.test(o.naam); }
    var heeftDiep = opstellingen.filter(isDiep).length >= 4;
    opstellingen.forEach(function (o) { if (o.lr) state.richting[o.naam] = 'Links'; });

    function opstellingVan(naam) { return opstellingen.filter(function (o) { return o.naam === naam; })[0] || null; }
    function stofVan(naam) { return stoffen.filter(function (s) { return s.naam === naam; })[0] || null; }
    function huidigeGroep() { var s = stofVan(state.stof); return s ? s.groep : null; }

    function variantVoor(ops, groep) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.opstelling !== ops) continue;
        if (!cfg.heeftStofgroep || v.stofgroep === groep) return v;
      }
      return null;
    }

    function basisPrijs(naamOps) {
      var ov = ovVan(opstellingVan(naamOps));
      var laagste = null;
      variants.forEach(function (v) { if (v.opstelling === ov && v.beschikbaar && (laagste === null || v.prijs < laagste)) laagste = v.prijs; });
      return laagste;
    }

    function groepLeverbaar(naamOps, groep) {
      if (!cfg.heeftStofgroep) return true;
      var v = variantVoor(ovVan(opstellingVan(naamOps)), groep);
      return !!(v && v.beschikbaar);
    }

    /* Foutmelding met een mens erachter */
    function toonFout(tekst, metBel) {
      if (!el.fout) return;
      el.fout.textContent = tekst;
      if (metBel && cfg.telefoonLink && cfg.telefoon) {
        el.fout.appendChild(document.createTextNode(' Of bel ons op '));
        var a = document.createElement('a');
        a.href = 'tel:' + cfg.telefoonLink;
        a.textContent = cfg.telefoon;
        el.fout.appendChild(a);
        el.fout.appendChild(document.createTextNode(' — dan kijken we mee.'));
      }
      el.fout.hidden = false;
    }

    /* ---------- Opbouwen: tegels ---------- */
    if (el.tegels && modulair) {
      /* Elementen: tik = toevoegen; een teller rechtsboven, een min-knop linksboven */
      el.tegels.removeAttribute('role');
      el.tegels.classList.add('pbp-tegels--samen');
      el.tegels.innerHTML = opstellingen.map(function (o) {
        var maat = (o.breedte && o.diepte) ? o.breedte + ' × ' + o.diepte + ' cm' : '';
        return '<div class="pbp-tegel pbp-tegel--samen" data-pbp-tegel="' + attr(o.naam) + '">' +
          '<button type="button" class="pbp-tegel__knop" data-pbp-plus="' + attr(o.naam) + '" aria-label="' + attr(o.naam) + ' toevoegen">' +
          '<span class="pbp-tegel__icoon" data-pbp-icoon>' + tegelBeeld(o) + '</span>' +
          '<span class="pbp-tegel__tekst"><span class="pbp-tegel__naam"></span>' +
          (maat ? '<span class="pbp-tegel__maat">' + maat + '</span>' : '') +
          '<span class="pbp-tegel__prijs" data-pbp-tegel-prijs></span><span class="pbp-tegel__plus">+ Toevoegen</span></span></button>' +
          '<span class="pbp-tegel__aantal" data-pbp-tegel-aantal hidden></span>' +
          '<button type="button" class="pbp-tegel__min" data-pbp-min="' + attr(o.naam) + '" aria-label="Eén ' + attr(o.naam) + ' minder" hidden>&minus;</button></div>';
      }).join('');
      Array.prototype.forEach.call(el.tegels.querySelectorAll('[data-pbp-tegel]'), function (b, i) {
        b.querySelector('.pbp-tegel__naam').textContent = opstellingen[i].naam;
      });
    } else if (el.tegels) {
      el.tegels.innerHTML = opstellingen.map(function (o, i) {
        var pers = personen(o);
        var maat = (o.breedte && o.diepte) ? o.breedte + ' × ' + o.diepte + ' cm' : '';
        return '<button type="button" class="pbp-tegel" role="radio" aria-checked="false" tabindex="' + (i === 0 ? 0 : -1) + '" data-pbp-tegel="' + attr(o.naam) + '">' +
          '<span class="pbp-tegel__icoon" data-pbp-icoon>' + tegelBeeld(o, state.richting[o.naam]) + '</span>' +
          (o.badge ? '<span class="pbp-tegel__badge">' + attr(o.badge) + '</span>' : '') +
          '<span class="pbp-tegel__tekst"><span class="pbp-tegel__naam"></span>' +
          (pers ? '<span class="pbp-tegel__maat">voor ' + attr(pers) + ' personen</span>' : (maat ? '<span class="pbp-tegel__maat">' + maat + '</span>' : '')) +
          '<span class="pbp-tegel__prijs" data-pbp-tegel-prijs></span></span></button>';
      }).join('');
      Array.prototype.forEach.call(el.tegels.querySelectorAll('[data-pbp-tegel]'), function (b, i) {
        b.querySelector('.pbp-tegel__naam').textContent = opstellingen[i].naam;
        b.addEventListener('click', function () { kiesOpstelling(opstellingen[i].naam); });
      });
      pijltjes(el.tegels, '[data-pbp-tegel]', function (b) { kiesOpstelling(b.dataset.pbpTegel); });
    }

    /* ---------- Opbouwen: families + stalen ---------- */
    var aanwezigeFamilies = FAMILIES.filter(function (f) { return stoffen.some(function (s) { return s.familie === f.key; }); });
    var heeftLeer = stoffen.some(function (s) { return s.leer; });

    if (el.families) {
      var chips = '<button type="button" class="pbp-familie" aria-pressed="true" tabindex="0" data-pbp-familie="alle">Alle kleuren</button>';
      aanwezigeFamilies.forEach(function (f) {
        chips += '<button type="button" class="pbp-familie" aria-pressed="false" tabindex="-1" data-pbp-familie="' + f.key + '"><i style="background:' + f.kleur + '"></i>' + f.naam + '</button>';
      });
      if (heeftLeer) chips += '<button type="button" class="pbp-familie" aria-pressed="false" tabindex="-1" data-pbp-familie="leer">Leer</button>';
      el.families.innerHTML = chips;
      Array.prototype.forEach.call(el.families.querySelectorAll('[data-pbp-familie]'), function (b) {
        b.addEventListener('click', function () { kiesFamilie(b.dataset.pbpFamilie); });
      });
      pijltjes(el.families, '[data-pbp-familie]', function (b) { kiesFamilie(b.dataset.pbpFamilie); });
    }

    if (el.stalen) {
      el.stalen.innerHTML = stoffen.map(function (s, i) {
        var stijl = 'background-color:' + s.kleur + ';' + (s.foto ? 'background-image:url(' + s.foto + ');' : '');
        return '<button type="button" class="pbp-staal" role="radio" aria-checked="false" tabindex="-1" data-pbp-staal="' + i + '" style="' + stijl + '" aria-label="' + attr(s.naam) + ', ' + soortTekst(s.groep) + '"></button>';
      }).join('');
      Array.prototype.forEach.call(el.stalen.querySelectorAll('[data-pbp-staal]'), function (b) {
        b.addEventListener('click', function () { kiesStof(stoffen[parseInt(b.dataset.pbpStaal, 10)].naam); });
      });
      pijltjes(el.stalen, '[data-pbp-staal]', function (b) { kiesStof(stoffen[parseInt(b.dataset.pbpStaal, 10)].naam); });
    }

    /* ---------- Galerij ---------- */
    var slides = el.stage ? Array.prototype.slice.call(el.stage.querySelectorAll('[data-pbp-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pbp-thumb]'));
    var ids = slides.map(function (s) { return s.dataset.mediaId; });
    var voortgang = root.querySelector('.p5p-gallery__progress-bar');

    function zetVoortgang(id) {
      if (!voortgang || ids.length < 2) return;
      var i = ids.indexOf(String(id));
      if (i === -1) return;
      voortgang.style.width = (100 / ids.length) + '%';
      voortgang.style.left = (i / ids.length * 100) + '%';
    }

    function toonSlide(id) {
      id = String(id);
      if (ids.indexOf(id) === -1) return;
      slides.forEach(function (s) {
        var actief = s.dataset.mediaId === id;
        s.classList.toggle('is-active', actief);
        s.setAttribute('aria-hidden', actief ? 'false' : 'true');
      });
      thumbs.forEach(function (t) {
        var actief = t.dataset.mediaId === id;
        t.classList.toggle('is-active', actief);
        if (actief) { t.setAttribute('aria-current', 'true'); centreerThumb(t); }
        else t.removeAttribute('aria-current');
      });
      renderBadge(id);
      zetVoortgang(id);
    }

    /* Alleen de thumbstrook zelf scrollen — nooit het venster, anders springt de
       pagina op mobiel bij elke stofkeuze terug naar de galerij */
    function centreerThumb(t) {
      var strook = t.parentNode;
      if (!strook || !strook.hasAttribute || !strook.hasAttribute('data-pbp-thumbs')) return;
      var links = t.offsetLeft - (strook.clientWidth - t.offsetWidth) / 2;
      if (strook.scrollTo) strook.scrollTo({ left: links, behavior: SCROLL }); else strook.scrollLeft = links;
    }

    function dotHtml(s) {
      return '<i style="background-color:' + s.kleur + ';' + (s.foto ? 'background-image:url(' + s.foto + ')' : '') + '"></i>';
    }

    function renderBadge(id) {
      if (!el.badge) return;
      var info = slideInfo[id];
      var stof = stofVan(state.stof);
      if (!info) { el.badge.hidden = true; return; }
      if (info.type === 'stof') {
        var opFoto = stoffen.filter(function (x) { return x.naam.toLowerCase() === info.waarde.toLowerCase(); })[0];
        var html = (opFoto ? dotHtml(opFoto) : '') + 'Op de foto: <strong>' + attr(info.waarde) + '</strong>';
        /* Klant koos een stof zonder eigen foto: zeg dat eerlijk in plaats van stil te blijven */
        if (stof && stof.naam.toLowerCase() !== info.waarde.toLowerCase()) {
          html += ' · jouw keuze: ' + dotHtml(stof) + '<strong>' + attr(stof.naam) + '</strong>';
        }
        el.badge.innerHTML = html;
      } else if (info.type === 'kleur') {
        el.badge.innerHTML = 'Kleurimpressie · ingekleurd in ' + attr(familieNaam(info.waarde).toLowerCase() || info.waarde) +
          (stof ? ' · jouw keuze: ' + dotHtml(stof) + '<strong>' + attr(stof.naam) + '</strong>' : '');
      } else {
        el.badge.textContent = info.waarde;
      }
      el.badge.hidden = false;
    }

    thumbs.forEach(function (t) { t.addEventListener('click', function () { toonSlide(t.dataset.mediaId); }); });

    if (el.stage && ids.length > 1) {
      var startX = null;
      el.stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      el.stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX; startX = null;
        if (Math.abs(dx) < 40) return;
        var actief = el.stage.querySelector('[data-pbp-slide].is-active');
        var i = actief ? ids.indexOf(actief.dataset.mediaId) : 0;
        if (dx < 0 && i < ids.length - 1) toonSlide(ids[i + 1]);
        else if (dx > 0 && i > 0) toonSlide(ids[i - 1]);
      }, { passive: true });
    }

    /* Foto laten volgen: eerst exacte stof, dan kleurfamilie */
    function fotoVoorStof(s) {
      if (!s) return null;
      return fotoStof[s.naam.toLowerCase()] || fotoFamilie[s.familie] || null;
    }

    /* ---------- Render ---------- */
    var prijsTimer = null;

    function renderOpstelling() {
      var o = opstellingVan(state.opstelling);
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-tegel]'), function (b) {
        var oo = opstellingVan(b.dataset.pbpTegel);
        if (modulair) {
          var q = state.samen[b.dataset.pbpTegel] || 0;
          b.classList.toggle('is-gekozen', q > 0);
          var ae = b.querySelector('[data-pbp-tegel-aantal]');
          if (ae) { ae.textContent = q + '×'; ae.hidden = !q; }
          var me = b.querySelector('[data-pbp-min]');
          if (me) me.hidden = !q;
          var pl = b.querySelector('.pbp-tegel__plus');
          if (pl) pl.textContent = q ? '+ Nog een' : '+ Toevoegen';
          var weg = !!(state.groep !== 'alle' && oo && groepVan(oo) !== state.groep);
          if (heeftDiep && oo && state.diep !== 'alle' && (state.diep === 'diep') !== isDiep(oo)) weg = true;
          b.hidden = weg;
          return;
        }
        var actief = b.dataset.pbpTegel === state.opstelling;
        b.setAttribute('aria-checked', actief ? 'true' : 'false');
        b.tabIndex = actief ? 0 : -1;
        if (oo && oo.lr) b.querySelector('[data-pbp-icoon]').innerHTML = tegelBeeld(oo, state.richting[oo.naam]);
      });
      if (modulair) {
        var tt = samenTotaal(huidigeGroep());
        if (el.opsLabel) el.opsLabel.textContent = 'Stel je bank samen';
        if (el.opsWaarde) el.opsWaarde.textContent = tt.aantal ? tt.aantal + (tt.aantal === 1 ? ' element' : ' elementen') : '';
        if (el.opsUitleg) el.opsUitleg.textContent = tt.aantal ? '' : 'Tik op een element om het toe te voegen. Je ziet meteen de totaalprijs; alles komt in dezelfde stof.';
      } else {
        if (el.opsWaarde) el.opsWaarde.textContent = o ? o.naam : '';
        if (el.opsUitleg) el.opsUitleg.textContent = o && o.uitleg ? o.uitleg : '';
      }

      if (el.richting) {
        var lr = !!(o && o.lr);
        el.richting.hidden = !lr;
        if (lr) {
          var deel = deelNaam(o);
          if (el.richtingLabel) el.richtingLabel.textContent = deel.charAt(0).toUpperCase() + deel.slice(1);
          if (el.richtingGroep) el.richtingGroep.setAttribute('aria-label', 'Aan welke kant komt het ' + deel + '?');
          Array.prototype.forEach.call(el.richting.querySelectorAll('[data-pbp-richting-knop]'), function (b) {
            var actiefR = state.richting[o.naam] === b.dataset.pbpRichtingKnop;
            b.setAttribute('aria-checked', actiefR ? 'true' : 'false');
            b.tabIndex = actiefR ? 0 : -1;
          });
        }
      }

      if (o) {
        if (el.matenTekening) { var mb = beeldVoor(o, state.richting[o.naam]); el.matenTekening.innerHTML = mb ? '<img src="' + attr(mb) + '" alt="" loading="lazy">' : ''; el.matenTekening.hidden = !mb; }
        if (el.matenKort) el.matenKort.textContent = (o.breedte && o.diepte) ? o.breedte + ' breed × ' + o.diepte + ' diep' : '';
        if (el.matenLijst) {
          var m = cfg.maten || {};
          var regels = [['Breedte', o.breedte + ' cm'], ['Diepte', o.diepte + ' cm']];
          if (m.hoogte) regels.push(['Hoogte', m.hoogte + ' cm']);
          if (m.zithoogte) regels.push(['Zithoogte', m.zithoogte + ' cm']);
          if (m.zitdiepte) regels.push(['Zitdiepte', m.zitdiepte + ' cm']);
          if (m.armleuning) regels.push(['Armleuning', m.armleuning + ' cm']);
          el.matenLijst.innerHTML = regels.map(function (r) { return '<div><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>'; }).join('');
        }
      }
    }

    function renderStoffen(meldAantal) {
      var s = stofVan(state.stof);
      var ops = state.opstelling;
      var basis = basisPrijs(ops);

      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-familie]'), function (b) {
        var actief = b.dataset.pbpFamilie === state.familie;
        b.setAttribute('aria-pressed', actief ? 'true' : 'false');
        b.tabIndex = actief ? 0 : -1;
      });

      /* Eerste indruk rustig houden: een beperkt aantal stalen, de rest achter "Toon alle" */
      var max = 18;
      var eersteZichtbaar = null, getoond = 0, passend = 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-staal]'), function (b) {
        var st = stoffen[parseInt(b.dataset.pbpStaal, 10)];
        var pastFamilie = state.familie === 'alle' || (state.familie === 'leer' ? st.leer : st.familie === state.familie);
        var leverbaar = groepLeverbaar(ops, st.groep);
        var actief = st.naam === state.stof;
        var past = pastFamilie && leverbaar;
        if (past) passend++;
        var toon = past && (state.alles || actief || getoond < max);
        if (toon && past) getoond++;
        b.hidden = !toon;
        b.setAttribute('aria-checked', actief ? 'true' : 'false');
        b.tabIndex = actief ? 0 : -1;
        if (!b.hidden && !eersteZichtbaar) eersteZichtbaar = b;
      });
      if (eersteZichtbaar && !root.querySelector('[data-pbp-staal][aria-checked="true"]:not([hidden])')) eersteZichtbaar.tabIndex = 0;

      var famNaam = null;
      if (state.familie === 'leer') famNaam = 'leer';
      else if (state.familie !== 'alle') famNaam = familieNaam(state.familie).toLowerCase() || null;

      if (el.meer) {
        var verborgen = passend - getoond;
        if (state.alles && passend > max) {
          el.meer.hidden = false;
          el.meer.textContent = 'Minder stoffen tonen';
          el.meer.setAttribute('aria-expanded', 'true');
        } else if (verborgen > 0) {
          el.meer.hidden = false;
          el.meer.textContent = 'Toon alle ' + passend + (famNaam ? ' in ' + famNaam : ' stoffen');
          el.meer.setAttribute('aria-expanded', 'false');
        } else {
          el.meer.hidden = true;
        }
      }

      if (meldAantal && el.melding) {
        el.melding.textContent = passend + (passend === 1 ? ' stof' : ' stoffen') + (famNaam ? ' in ' + famNaam : '');
      }

      if (el.stofWaarde) el.stofWaarde.textContent = s ? s.naam : '';
      if (el.infoNaam) el.infoNaam.textContent = s ? s.naam : 'Kies een stof';
      if (el.infoDot && s) el.infoDot.style.cssText = 'background-color:' + s.kleur + ';' + (s.foto ? 'background-image:url(' + s.foto + ')' : '');
      /* Grote stofkaart: de close-up van de gekozen stof, tikbaar voor fullscreen */
      if (el.kaartImg && s) {
        var groot = s.fotoGroot || s.foto;
        if (groot) { if (el.kaartImg.getAttribute('src') !== groot) el.kaartImg.src = groot; el.kaartImg.style.backgroundColor = s.kleur; el.kaartImg.hidden = false; }
        else { el.kaartImg.removeAttribute('src'); el.kaartImg.hidden = true; }
        el.kaartImg.parentNode.style.backgroundColor = s.kleur;
        el.kaartImg.alt = 'Close-up van de ' + soortTekst(s.groep) + ' ' + s.naam;
        if (el.kaartKnop) { el.kaartKnop.disabled = !s.fotoGroot; el.kaartKnop.setAttribute('aria-label', s.fotoGroot ? 'Bekijk ' + s.naam + ' groot' : s.naam); }
        if (el.kaartZoom) el.kaartZoom.hidden = !s.fotoGroot;
      }
      if (el.infoExtra) {
        var extra = '';
        if (s) {
          /* Wat de stof is (uit het metafield: "velours, zacht, makkelijk schoon"), anders alleen stof/leer */
          extra = s.info || soortTekst(s.groep);
          if (cfg.heeftStofgroep && basis !== null) {
            var v = variantVoor(ovVan(opstellingVan(ops)), s.groep);
            if (v) extra += v.prijs - basis > 0 ? ' · meerprijs + ' + formatKort(v.prijs - basis, cfg.moneyFormat) : ' · geen meerprijs';
          }
        }
        el.infoExtra.textContent = extra;
      }
    }

    function renderPrijs() {
      var o = opstellingVan(state.opstelling);
      var s = stofVan(state.stof);
      var groep = s ? s.groep : null;
      if (modulair) { renderPrijsModulair(s, groep); return; }
      var v = variantVoor(ovVan(o), groep);
      var tekst = (v && v.beschikbaar) ? formatMoney(v.prijs, cfg.moneyFormat) : '—';

      var sub = '';
      if (o) sub += o.naam;
      if (o && o.lr && state.richting[o.naam]) sub += ' · ' + deelNaam(o) + ' ' + state.richting[o.naam].toLowerCase();
      if (s) sub += ' · ' + s.naam;

      /* Bedrag en regel eronder in één keer schrijven, zodat een schermlezer het één keer hoort */
      var schrijfSub = function () { if (el.prijsSub) el.prijsSub.textContent = sub || ' '; };
      if (el.prijs && el.prijs.textContent !== tekst) {
        el.prijs.classList.add('is-wisselt');
        window.clearTimeout(prijsTimer);
        prijsTimer = window.setTimeout(function () { el.prijs.textContent = tekst; el.prijs.classList.remove('is-wisselt'); schrijfSub(); }, 140);
      } else {
        schrijfSub();
      }

      /* Prijs per tegel: wat deze opstelling kost in de stof die nu gekozen is */
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-tegel]'), function (b) {
        var pv = variantVoor(ovVan(opstellingVan(b.dataset.pbpTegel)), groep);
        var pe = b.querySelector('[data-pbp-tegel-prijs]');
        if (pe) pe.textContent = (pv && pv.beschikbaar) ? formatKort(pv.prijs, cfg.moneyFormat) : '';
      });

      if (el.variantId) el.variantId.value = v ? v.id : '';
      if (el.propStof) el.propStof.value = s ? s.naam : '';
      if (el.propRichting) {
        /* Richting alleen als eigenschap meesturen als er geen spiegelvariant is die het al zegt */
        var lr = !!(o && o.lr && !o.ovRechts);
        el.propRichting.disabled = !lr;
        el.propRichting.value = lr ? state.richting[o.naam] : '';
      }

      var kan = !!(v && v.beschikbaar && (s || !stoffen.length));
      if (el.atc) {
        el.atc.disabled = !kan;
        if (el.atcTekst) el.atcTekst.textContent = (v && !v.beschikbaar) ? 'NIET LEVERBAAR IN DEZE STOF' : 'IN WINKELWAGEN';
        if (el.atcPrijs) el.atcPrijs.textContent = kan ? '· ' + formatKort(v.prijs, cfg.moneyFormat) : '';
      }
      if (el.balkPrijs) el.balkPrijs.textContent = tekst;
      if (el.balkSub) el.balkSub.textContent = sub;
      if (el.balkKnop) el.balkKnop.disabled = !kan;
      /* "Jouw bank": één regel die alles bevestigt vlak voor de knop */
      if (el.sam) {
        el.sam.hidden = !o;
        if (o) {
          if (el.samRegel) el.samRegel.textContent = sub;
          if (el.samPrijs) el.samPrijs.textContent = tekst;
          if (el.samStof) {
            var samBeeld = s ? (s.fotoGroot || s.foto) : '';
            el.samStof.style.cssText = s ? 'background-color:' + s.kleur + ';' + (samBeeld ? 'background-image:url(' + samBeeld + ')' : '') : '';
            el.samStof.hidden = !s;
          }
        }
      }
      var klarnaOk = !!(v && cfg.klarnaGrens > 0 && v.prijs < cfg.klarnaGrens);
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-klarna], [data-pbp-klarna-tekst]'), function (k) { k.hidden = !klarnaOk; });

      if (el.fout && state.opstelling) {
        if (!v) toonFout('Deze stof kan niet op deze bank. Kies een andere stof.', true);
        else if (!el.fout.dataset.server) el.fout.hidden = true;
      }
    }

    function renderAlles() { renderOpstelling(); renderStoffen(false); renderPrijs(); if (modulair) renderSamen(); }

    /* ---------- Elementenbank: samenstellen ---------- */
    function samenTotaal(groep) {
      var tot = 0, n = 0, regels = [], kapot = [], rijen = [];
      opstellingen.forEach(function (o) {
        var q = state.samen[o.naam] || 0;
        if (!q) return;
        var pv = variantVoor(o.ov, groep);
        var ok = !!(pv && pv.beschikbaar);
        if (ok) { tot += pv.prijs * q; n += q; } else kapot.push(o.naam);
        regels.push(q + '× ' + o.naam);
        rijen.push({ o: o, q: q, v: pv, ok: ok });
      });
      return { totaal: tot, aantal: n, regels: regels, kapot: kapot, rijen: rijen };
    }
    function laagsteElement(groep) {
      /* "vanaf"-prijs: het goedkoopste zitelement, niet een poef of kussen */
      var l = null, alleenLos = opstellingen.every(function (o) { return groepVan(o) === 'los'; });
      opstellingen.forEach(function (o) {
        if (!alleenLos && groepVan(o) === 'los') return;
        var pv = variantVoor(o.ov, groep);
        if (pv && pv.beschikbaar && (l === null || pv.prijs < l)) l = pv.prijs;
      });
      return l;
    }
    function zetAantal(naam, q) {
      var o = opstellingVan(naam);
      if (!o) return;
      q = Math.max(0, Math.min(20, q));
      if (q) state.samen[naam] = q; else delete state.samen[naam];
      state.opstelling = naam;
      renderAlles();
      /* de tekening van dit element in de galerij tonen, als die er is */
      var pv = variantVoor(o.ov, huidigeGroep());
      var id = fotoOpstelling[naam.toLowerCase()] || (pv && pv.foto ? String(pv.foto) : null);
      if (id && ids.indexOf(String(id)) !== -1) toonSlide(id);
    }
    function plusEen(naam) { zetAantal(naam, (state.samen[naam] || 0) + 1); }
    function minEen(naam) { zetAantal(naam, (state.samen[naam] || 0) - 1); }

    function renderGroepen() {
      if (!el.groepen || !modulair) return;
      var telling = {};
      opstellingen.forEach(function (o) { var g = groepVan(o); telling[g] = (telling[g] || 0) + 1; });
      var aanwezig = GROEPEN.filter(function (g) { return telling[g.key]; });
      if (aanwezig.length < 3) { el.groepen.hidden = true; return; }
      var html = '<button type="button" class="pbp-familie" aria-pressed="' + (state.groep === 'alle') + '" data-pbp-groep="alle">Alles <small>' + opstellingen.length + '</small></button>';
      aanwezig.forEach(function (g) {
        html += '<button type="button" class="pbp-familie" aria-pressed="' + (state.groep === g.key) + '" data-pbp-groep="' + g.key + '">' + g.naam + ' <small>' + telling[g.key] + '</small></button>';
      });
      if (heeftDiep) {
        html += '<span class="pbp-groep-scheiding" aria-hidden="true"></span>' +
          '<button type="button" class="pbp-familie" aria-pressed="' + (state.diep === 'normaal') + '" data-pbp-diep="normaal">Normale zitdiepte</button>' +
          '<button type="button" class="pbp-familie" aria-pressed="' + (state.diep === 'diep') + '" data-pbp-diep="diep">Diep</button>';
      }
      el.groepen.innerHTML = html;
      el.groepen.hidden = false;
    }

    function renderSamen() {
      if (!el.samen || !modulair) return;
      var s = stofVan(state.stof);
      var t = samenTotaal(s ? s.groep : null);
      if (!t.rijen.length) { el.samen.hidden = true; el.samen.innerHTML = ''; return; }
      var html = '<div class="pbp-samen__kop"><strong>Jouw samenstelling</strong><span>' + t.aantal + (t.aantal === 1 ? ' element' : ' elementen') + (s ? ' · ' + attr(s.naam) : '') + '</span></div><ul class="pbp-samen__lijst">';
      t.rijen.forEach(function (r) {
        var beeld = beeldVoor(r.o);
        var maat = (r.o.breedte && r.o.diepte) ? r.o.breedte + ' × ' + r.o.diepte + ' cm' : '';
        html += '<li class="pbp-samen__rij">' +
          (beeld ? '<img class="pbp-samen__beeld" src="' + attr(beeld) + '" alt="" loading="lazy">' : '<span class="pbp-samen__beeld"></span>') +
          '<span class="pbp-samen__naam">' + attr(r.o.naam) + (maat ? '<small>' + maat + '</small>' : '') + (r.ok ? '' : '<em>Niet leverbaar in deze stof</em>') + '</span>' +
          '<span class="pbp-stepper"><button type="button" data-pbp-min="' + attr(r.o.naam) + '" aria-label="Eén ' + attr(r.o.naam) + ' minder">&minus;</button><b>' + r.q + '</b><button type="button" data-pbp-plus="' + attr(r.o.naam) + '" aria-label="Eén ' + attr(r.o.naam) + ' extra">+</button></span>' +
          '<span class="pbp-samen__prijs">' + (r.ok ? formatKort(r.v.prijs * r.q, cfg.moneyFormat) : '—') + '</span></li>';
      });
      html += '</ul><div class="pbp-samen__totaal"><span>Totaal' + (s ? ', in ' + attr(s.naam) : '') + '</span><strong>' + formatMoney(t.totaal, cfg.moneyFormat) + '</strong></div>' +
        '<p class="pbp-samen__hint">Alle elementen komen in dezelfde stof. Losse elementen kun je later altijd bijbestellen.</p>';
      el.samen.innerHTML = html;
      el.samen.hidden = false;
    }

    function renderPrijsModulair(s, groep) {
      var t = samenTotaal(groep);
      var leeg = !t.rijen.length;
      var laag = laagsteElement(groep);
      var tekst = leeg ? (laag !== null ? 'vanaf ' + formatKort(laag, cfg.moneyFormat) : '—') : formatMoney(t.totaal, cfg.moneyFormat);
      var sub = leeg ? 'Stel je bank samen uit losse elementen' : t.aantal + (t.aantal === 1 ? ' element' : ' elementen') + (s ? ' · ' + s.naam : '');
      if (el.prijs) el.prijs.textContent = tekst;
      if (el.prijsSub) el.prijsSub.textContent = sub;
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-tegel]'), function (b) {
        var pv = variantVoor(ovVan(opstellingVan(b.dataset.pbpTegel)), groep);
        var pe = b.querySelector('[data-pbp-tegel-prijs]');
        if (pe) pe.textContent = (pv && pv.beschikbaar) ? formatKort(pv.prijs, cfg.moneyFormat) : 'niet in deze stof';
      });
      if (el.variantId) el.variantId.value = '';
      if (el.propStof) el.propStof.value = s ? s.naam : '';
      if (el.propRichting) { el.propRichting.disabled = true; el.propRichting.value = ''; }
      var kan = !leeg && !t.kapot.length && !!(s || !stoffen.length);
      if (el.atc) {
        el.atc.disabled = !kan;
        if (el.atcTekst) el.atcTekst.textContent = leeg ? 'KIES EERST JE ELEMENTEN' : (t.kapot.length ? 'NIET LEVERBAAR IN DEZE STOF' : 'ALLES IN WINKELWAGEN');
        if (el.atcPrijs) el.atcPrijs.textContent = kan ? '· ' + formatKort(t.totaal, cfg.moneyFormat) : '';
      }
      if (el.balkPrijs) el.balkPrijs.textContent = tekst;
      if (el.balkSub) el.balkSub.textContent = sub;
      if (el.balkKnop) { el.balkKnop.disabled = !kan; el.balkKnop.textContent = leeg ? 'KIES JE ELEMENTEN' : 'IN WINKELWAGEN'; }
      if (el.sam) {
        el.sam.hidden = leeg;
        if (!leeg) {
          if (el.samRegel) el.samRegel.textContent = t.regels.join(', ') + (s ? ' · ' + s.naam : '');
          if (el.samPrijs) el.samPrijs.textContent = tekst;
          if (el.samStof) {
            var sb = s ? (s.fotoGroot || s.foto) : '';
            el.samStof.style.cssText = s ? 'background-color:' + s.kleur + ';' + (sb ? 'background-image:url(' + sb + ')' : '') : '';
            el.samStof.hidden = !s;
          }
        }
      }
      var klarnaOk = !leeg && cfg.klarnaGrens > 0 && t.totaal < cfg.klarnaGrens;
      Array.prototype.forEach.call(root.querySelectorAll('[data-pbp-klarna], [data-pbp-klarna-tekst]'), function (k) { k.hidden = !klarnaOk; });
      if (el.fout) {
        if (t.kapot.length) toonFout('Niet leverbaar in deze stof: ' + t.kapot.join(', ') + '. Kies een andere stof of haal het element weg.', true);
        else if (!el.fout.dataset.server) el.fout.hidden = true;
      }
    }

    if (modulair) {
      root.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t) return;
        var p = t.closest('[data-pbp-plus]');
        if (p) { e.preventDefault(); plusEen(p.dataset.pbpPlus); return; }
        var m = t.closest('[data-pbp-min]');
        if (m) { e.preventDefault(); minEen(m.dataset.pbpMin); return; }
        var g = t.closest('[data-pbp-groep]');
        if (g) { state.groep = g.dataset.pbpGroep; renderGroepen(); renderOpstelling(); return; }
        var dp = t.closest('[data-pbp-diep]');
        if (dp) { state.diep = state.diep === dp.dataset.pbpDiep ? 'alle' : dp.dataset.pbpDiep; renderGroepen(); renderOpstelling(); }
      });
      renderGroepen();
    }

    /* ---------- Keuzes ---------- */
    function kiesOpstelling(naam) {
      state.opstelling = naam;
      var s = stofVan(state.stof);
      if (s && !groepLeverbaar(naam, s.groep)) {
        var alt = stoffen.filter(function (x) { return groepLeverbaar(naam, x.groep); })[0];
        state.stof = alt ? alt.naam : null;
      }
      renderAlles();
      var id = fotoOpstelling[naam.toLowerCase()];
      if (id) toonSlide(id);
    }

    function kiesStof(naam) {
      state.stof = naam;
      renderAlles();
      var id = fotoVoorStof(stofVan(naam));
      if (id) toonSlide(id);
      else { var actief = el.stage && el.stage.querySelector('[data-pbp-slide].is-active'); if (actief) renderBadge(actief.dataset.mediaId); }
    }

    function kiesFamilie(key) {
      state.familie = key;
      state.alles = false;
      renderStoffen(true);
    }

    if (el.meer) {
      el.meer.addEventListener('click', function () {
        state.alles = !state.alles;
        renderStoffen(false);
        if (!state.alles && el.stalen) el.stalen.scrollIntoView({ behavior: SCROLL, block: 'start' });
      });
    }

    function kiesRichting(knop) {
      var o = opstellingVan(state.opstelling);
      if (!o || !o.lr) return;
      state.richting[o.naam] = knop.dataset.pbpRichtingKnop;
      renderAlles();
    }

    if (el.richting) {
      Array.prototype.forEach.call(el.richting.querySelectorAll('[data-pbp-richting-knop]'), function (b) {
        b.addEventListener('click', function () { kiesRichting(b); });
      });
      pijltjes(el.richtingGroep, '[data-pbp-richting-knop]', kiesRichting);
    }

    /* ---------- In winkelwagen ---------- */
    if (el.form) {
      el.form.addEventListener('submit', function (e) {
        if (modulair) {
          /* Alle gekozen elementen in één keer, allemaal in dezelfde stof */
          e.preventDefault();
          if (el.atc.disabled) return;
          var s0 = stofVan(state.stof);
          var t0 = samenTotaal(s0 ? s0.groep : null);
          if (!t0.rijen.length || t0.kapot.length) return;
          var items = t0.rijen.map(function (r) {
            var props = { Samenstelling: t0.regels.join(', ') };
            if (s0) props.Stofkleur = s0.naam;
            return { id: r.v.id, quantity: r.q, properties: props };
          });
          var oud0 = el.atcTekst ? el.atcTekst.textContent : '';
          el.atc.disabled = true;
          if (el.atcTekst) el.atcTekst.textContent = 'BEZIG...';
          if (el.fout) { el.fout.hidden = true; delete el.fout.dataset.server; }
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status) {
                el.atc.disabled = false;
                if (el.atcTekst) el.atcTekst.textContent = oud0;
                toonFout(data.description || 'Toevoegen aan je winkelwagen lukte niet. Probeer het nog een keer.', true);
                if (el.fout) el.fout.dataset.server = '1';
                return;
              }
              ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { detail: { cart: data } })); });
              document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
              if (cfg.naCart !== 'blijf') { window.location.href = cfg.cartUrl || '/cart'; return; }
              if (el.atcTekst) el.atcTekst.textContent = 'TOEGEVOEGD ✓';
              window.setTimeout(function () { el.atc.disabled = false; if (el.atcTekst) el.atcTekst.textContent = oud0; }, 2000);
            })
            .catch(function () {
              el.atc.disabled = false;
              if (el.atcTekst) el.atcTekst.textContent = oud0;
              toonFout('Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.', true);
            });
          return;
        }
        if (!el.variantId || !el.variantId.value) return;
        e.preventDefault();
        if (el.atc.disabled) return;
        var oud = el.atcTekst ? el.atcTekst.textContent : '';
        el.atc.disabled = true;
        if (el.atcTekst) el.atcTekst.textContent = 'BEZIG...';
        if (el.fout) { el.fout.hidden = true; delete el.fout.dataset.server; }

        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(el.form) })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              el.atc.disabled = false;
              if (el.atcTekst) el.atcTekst.textContent = oud;
              toonFout(data.description || 'Toevoegen aan je winkelwagen lukte niet. Probeer het nog een keer.', true);
              if (el.fout) el.fout.dataset.server = '1';
              return;
            }
            ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { detail: { cart: data } })); });
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: data } }));
            if (cfg.naCart !== 'blijf') { window.location.href = cfg.cartUrl || '/cart'; return; }
            if (el.atcTekst) el.atcTekst.textContent = 'TOEGEVOEGD ✓';
            window.setTimeout(function () { el.atc.disabled = false; if (el.atcTekst) el.atcTekst.textContent = oud; }, 2000);
          })
          .catch(function () { el.form.submit(); });
      });
    }
    if (el.balkKnop && el.form) {
      el.balkKnop.addEventListener('click', function () {
        if (el.form.requestSubmit) el.form.requestSubmit(); else el.atc.click();
      });
    }

    /* Vaste balk zodra de echte knop uit beeld is; weer weg onderaan de sectie zodat de
       footer vrij blijft. Buiten beeld is de balk inert: niet klikbaar, niet focusbaar. */
    if (el.balk && el.atc && 'IntersectionObserver' in window) {
      var atcInBeeld = true, eindeInBeeld = false;
      var einde = root.querySelector('[data-pbp-einde]');
      function zetBalk() {
        var toon = !atcInBeeld && !eindeInBeeld;
        el.balk.classList.toggle('is-zichtbaar', toon);
        el.balk.setAttribute('aria-hidden', toon ? 'false' : 'true');
        if (toon) el.balk.removeAttribute('inert'); else el.balk.setAttribute('inert', '');
        if (el.balkKnop) el.balkKnop.tabIndex = toon ? 0 : -1;
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { atcInBeeld = en.isIntersecting; });
        zetBalk();
      }, { threshold: 0 }).observe(el.atc);
      if (einde) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { eindeInBeeld = en.isIntersecting; });
          zetBalk();
        }, { threshold: 0 }).observe(einde);
      }
    }

    /* ---------- Fullscreen bekijken (foto én stof), tik = inzoomen ---------- */
    var lightboxTerug = null;
    function grootsteSrc(img) {
      if (!img) return '';
      var set = img.getAttribute('srcset');
      if (set) { var delen = set.split(',').map(function (d) { return d.trim().split(/\s+/)[0]; }).filter(Boolean); if (delen.length) return delen[delen.length - 1]; }
      return img.currentSrc || img.src || '';
    }
    function openLightbox(src, noot, terug) {
      if (!el.lightbox || !el.lightboxImg || !src) return;
      lightboxTerug = terug || null;
      el.lightboxImg.src = src;
      el.lightboxImg.alt = noot || '';
      if (el.lightboxNoot) { el.lightboxNoot.textContent = noot || ''; el.lightboxNoot.hidden = !noot; }
      el.lightbox.classList.remove('is-zoom');
      if (el.lightboxScroll) { el.lightboxScroll.scrollTop = 0; el.lightboxScroll.scrollLeft = 0; }
      el.lightbox.hidden = false;
      document.documentElement.classList.add('pbp-vast');
      if (el.lightboxSluit) el.lightboxSluit.focus();
    }
    function sluitLightbox() {
      if (!el.lightbox || el.lightbox.hidden) return;
      el.lightbox.hidden = true;
      document.documentElement.classList.remove('pbp-vast');
      if (lightboxTerug && lightboxTerug.focus) lightboxTerug.focus({ preventScroll: true });
    }
    if (el.lightbox) {
      if (el.lightboxSluit) el.lightboxSluit.addEventListener('click', sluitLightbox);
      el.lightbox.addEventListener('click', function (e) { if (e.target === el.lightbox || e.target === el.lightboxScroll) sluitLightbox(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitLightbox(); });
      if (el.lightboxImg) {
        el.lightboxImg.addEventListener('click', function (e) {
          var zoom = el.lightbox.classList.toggle('is-zoom');
          if (zoom && el.lightboxScroll) {
            /* inzoomen op de plek waar getikt is */
            var r = el.lightboxImg.getBoundingClientRect();
            var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
            window.requestAnimationFrame(function () {
              el.lightboxScroll.scrollLeft = fx * el.lightboxScroll.scrollWidth - el.lightboxScroll.clientWidth / 2;
              el.lightboxScroll.scrollTop = fy * el.lightboxScroll.scrollHeight - el.lightboxScroll.clientHeight / 2;
            });
          }
        });
      }
      if (el.kaartKnop) {
        el.kaartKnop.addEventListener('click', function () {
          var s = stofVan(state.stof);
          if (s && s.fotoGroot) openLightbox(s.fotoGroot, s.naam + ' · ' + soortTekst(s.groep) + ' · tik om in te zoomen', el.kaartKnop);
        });
      }
      function openActieveFoto(terug) {
        var actief = el.stage && el.stage.querySelector('[data-pbp-slide].is-active img');
        if (!actief) return;
        var noot = el.badge && !el.badge.hidden ? el.badge.textContent : '';
        openLightbox(grootsteSrc(actief), (noot ? noot + ' · ' : '') + 'tik om in te zoomen', terug);
      }
      if (el.zoomKnop) el.zoomKnop.addEventListener('click', function () { openActieveFoto(el.zoomKnop); });
      if (el.stage) el.stage.addEventListener('click', function (e) { if (e.target && e.target.tagName === 'IMG' && e.target.closest('[data-pbp-slide]')) openActieveFoto(el.zoomKnop || el.stage); });
    }

    /* ---------- Startstand ---------- */
    var startVariant = variants.filter(function (v) { return String(v.id) === String(el.variantId && el.variantId.value); })[0];
    var startOps = null;
    if (startVariant) {
      opstellingen.forEach(function (o) {
        if (startOps) return;
        if (o.ov === startVariant.opstelling) startOps = o.naam;
        else if (o.ovRechts && o.ovRechts === startVariant.opstelling) { startOps = o.naam; state.richting[o.naam] = 'Rechts'; }
      });
    }
    if (!startOps) { var b0 = opstellingen.filter(function (o) { return o.badge; })[0]; startOps = b0 ? b0.naam : (opstellingen[0] ? opstellingen[0].naam : null); }
    state.opstelling = startOps;

    /* Standaardstof: de stof op de eerste foto, anders de eerste leverbare */
    var eersteSlideInfo = ids.length ? slideInfo[ids[0]] : null;
    var startStof = null;
    if (eersteSlideInfo && eersteSlideInfo.type === 'stof') {
      var sf = stoffen.filter(function (x) { return x.naam.toLowerCase() === eersteSlideInfo.waarde.toLowerCase(); })[0];
      if (sf && groepLeverbaar(startOps, sf.groep)) startStof = sf.naam;
    }
    if (!startStof) { var lever = stoffen.filter(function (x) { return groepLeverbaar(startOps, x.groep); })[0]; startStof = lever ? lever.naam : (stoffen[0] ? stoffen[0].naam : null); }
    state.stof = startStof;

    renderAlles();
    if (ids.length) { renderBadge(ids[0]); zetVoortgang(ids[0]); }
  }

  function initAlles(scope) { (scope || document).querySelectorAll('[data-p5-bank]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAlles(); });
  else initAlles();
  document.addEventListener('shopify:section:load', function (e) { initAlles(e.target); });
})();
